import { useEffect, useState } from "react";
import { ensureAppBridge, isEmbedded } from "../lib/shopifyAdmin";
import { inAdminArea } from "../lib/adminBase";
import { AdminAreaGate } from "./AdminAreaGate";
import { Brand } from "./Brand";

// /shop-app: renders children only inside the Shopify admin iframe with App Bridge available.
function EmbeddedGate({ children }) {
  const [ready, setReady] = useState(null); // null=checking, true=ok, false=not embedded

  useEffect(() => {
    let alive = true;
    if (!isEmbedded()) {
      setReady(false);
      return;
    }
    ensureAppBridge().then((ok) => alive && setReady(ok));
    return () => {
      alive = false;
    };
  }, []);

  if (ready === null) {
    return (
      <div data-testid="shop-admin-loading" className="min-h-screen grid place-items-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!ready) {
    return (
      <div data-testid="shop-admin-not-embedded" className="min-h-screen grid place-items-center bg-dots px-6 text-center">
        <div className="max-w-md">
          <Brand />
          <h1 className="font-heading text-2xl font-bold mt-6">Custom duck orders</h1>
          <p className="text-muted-foreground mt-3">Open this from the Duckify app in Shopify admin, or from Admin in your account menu.</p>
        </div>
      </div>
    );
  }
  return children;
}

// The same admin pages open in Shopify admin (/shop-app) and under the new login (/admin).
export function ShopAdminGate({ children }) {
  return inAdminArea() ? <AdminAreaGate min="staff">{children}</AdminAreaGate> : <EmbeddedGate>{children}</EmbeddedGate>;
}
